export const OnboardingApi = Symbol.for('OnboardingApi');
